module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "structure"
    }
  }, [_c('figure', {
    staticClass: "figure"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/WEILER_Fig.01.jpeg",
      "width": "459"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Figure 1.")]), _vm._v(" Maria Baldwin. Cambridge Historical Commission, Cambridge Public Library Collection.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af7cc81a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Weiler0003.vue
// module id = 63
// module chunks = 0